export * from './ng4-files-config';
export * from './ng4-files-selected';



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/ng4-files/declarations/index.ts